<template>
  <div class="serveUseAppList">
    <div class="flexend">
      <Input
        style="width: 300px"
        v-model.trim="search.number"
        placeholder="请输入应用名称"
        @on-enter="searchApp"
        clearable
        @on-clear="searchApp"
      ></Input>
      <Button class="ml-24" icon="ios-search" type="primary" shape="circle" @click="searchApp">搜索</Button>
    </div>
    <div class="serveUseAppList-list mt-24" v-if="dataList.length != 0">
      <div v-for="item in dataList" :key="item.id" class="serveUseAppList-list-item">
        <appItem @click.native="appClick(item)" class="mb-24" :item="item" />
      </div>
    </div>
    <Row class="mt-4" type="flex" justify="center" v-if="dataList.length != 0">
      <Page
        :total="pageTotal"
        :page-size="search.pageSize"
        :page-size-opts="psize"
        :current="search.pageIndex"
        @on-change="handlePage"
        @on-page-size-change="sizeChange"
        show-sizer
        show-total
        show-elevator
        placement="top"
        class-name="page"
      />
    </Row>
    <div v-if="dataList.length == 0" class="serveEmpty">
      <img src="@/assets/img/serveuse/serveuse_null_default.png" alt />
      <p class="fontthreedark">暂未创建应用</p>
    </div>
  </div>
</template>
<script>
import appItem from "@/components/card/app-item.vue";
import { getServePubilshlist } from "@/api/serviceUse";
export default {
  name: "",
  components: {
    appItem
  },
  data() {
    return {
      pageTotal: 0,
      psize: [6, 8, 10],
      search: {
        pageSize: 6,
        pageIndex: 1
      },
      dataList: []
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题-因分页用的地方太多，混入监听
    pageTotal() {
      const cPage = this.totalCount / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.getServePubilshlist(); //获取列表数据
      }
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getServePubilshlist();
  },
  methods: {
    searchApp() {
      this.search.pageIndex = 1;
      // this.search.pageSize = 6;
      this.getServePubilshlist();
    },
    getServePubilshlist() {
      let query = {
        uid: this.id,
        aName: this.search.number,
        pageIndex: this.search.pageIndex,
        pageSize: this.search.pageSize
      };
      console.log("sss", query);
      getServePubilshlist(query)
        .then(res => {
          console.log("服务使用者发布服应用列表", res);
          this.dataList = res.data.data;
          this.pageTotal = res.data.page.totalCount;
        })
        .catch(err => {});
    },
    //跳转详情
    appClick(item) {
      this.$router.push({
        path: "/serveUse/serveUseAppDetail",
        query: {
          id: item.id
        }
      });
    },
    // 分页==页码修改(ok)
    handlePage(value) {
      let self = this;
      self.search.pageIndex = value;
      self.getServePubilshlist();
    },
    // 分页==每页显示数量修改(ok)
    sizeChange(value) {
      let self = this;
      self.search.pageSize = value;
      self.$nextTick(() => {
        self.getServePubilshlist();
      });
    }
  }
};
</script>
<style lang="scss">
.serveUseAppList {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  overflow: auto;
  &-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &-item {
      width: calc(50% - 12px);
    }
  }
  .serveEmpty {
    padding-top: 100px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    p {
      width: 100%;
    }
  }
}
</style>